config.$inject = ['$logProvider', '$httpProvider', '$locationProvider', '$translateProvider'];

export default function config($logProvider, $httpProvider, $locationProvider, $translateProvider) {
  "ngInject";

  $httpProvider.interceptors.push('AuthInterceptorService');

  $translateProvider
    .useStaticFilesLoader({
      suffix: '.json',
      prefix: './translations/'
    })
    .preferredLanguage('en')
    .useSanitizeValueStrategy('escape')
    .registerAvailableLanguageKeys(['en', 'de'], {
       'en_US': 'en',
       'en_UK': 'en',
       'de_DE': 'de',
       'de_CH': 'de'
     })    
    .determinePreferredLanguage();

  $logProvider.debugEnabled(true);
}



// WEBPACK FOOTER //
// ./app/index.config.js